/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import Config from 'Config';
import { DataGridSearchFilter } from 'common/types/datagrid';
import MotiliTextButton from 'common/components/buttons/MotiliTextButton';
import ActiveFilterContainer from 'common/components/data-grid/ActiveFilterContainer';
import ActiveFilterPill from 'common/components/data-grid//ActiveFilterPill';

import styles from './DataGridActiveFilters-V2.module.scss';

interface DataGridActiveFiltersProps {
    onFilterClose: (key: string, index: number) => void;
    searchFilters: Record<string, DataGridSearchFilter[]>;
    onClearAll?: () => void;
}

const DataGridActiveFilters = ({
    onFilterClose,
    onClearAll,
    searchFilters = {},
}: DataGridActiveFiltersProps) => (
    <div className={styles.activeFiltersContainer}>
        <ActiveFilterContainer>
            {Object.keys(searchFilters)?.map(key => {
                return searchFilters[key].map((filter, index) => {
                    return (
                        <ActiveFilterPill
                            dataTestId={`applied-filter-${key}`}
                            key={filter.display}
                            clearable
                            onFilterClose={() => onFilterClose(key, index)}
                        >
                            {filter.display}
                        </ActiveFilterPill>
                    );
                });
            })}
        </ActiveFilterContainer>
        {Object.keys(searchFilters)?.length > 0 && onClearAll && (
            <RemoveAllButton onClearAll={onClearAll} />
        )}
    </div>
);

export default DataGridActiveFilters;

export const RemoveAllButton = ({ onClearAll }: { onClearAll: () => void }) => {
    return (
        <div className={styles.buttonWithIcon}>
            <DeleteOutlineIcon
                data-test-id='DeleteOutlineIcon'
                sx={{ color: Config.color.red }}
                fontSize='medium'
            />
            <MotiliTextButton
                color='red'
                text='REMOVE ALL'
                onClick={onClearAll}
            />
        </div>
    );
};

export { ActiveFilterContainer };
